/* eslint-disable react/require-default-props, no-unused-vars */
import { createTypeElement, createPropTypes } from './util'

const Tip = ({ as = 'span', ...props }) =>
  createTypeElement('Tip', { as, ...props })
Tip.propTypes = createPropTypes()
export default Tip
